//import _ from 'lodash'

import {Link} from 'react-router-dom';
import Terrain from '../../terrain/Terrain'
import CardTerrain from '../../terrain/CardTerrain'
import MotelTerrain from '../../terrain/MotelTerrain'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../../../constants'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
import '../../../css/svdreact.css'
import '../../../css/OrderDet.css'

//import TerrainLocationListView from '../../terrain/TerrainLocationListView'

// Load the full build.
const _ = require('lodash')
   const React = require('react')

  

   

   const HeartSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
      <path d="M923 283.6c-13.4-31.1-32.6-58.9-56.9-82.8-24.3-23.8-52.5-42.4-84-55.5-32.5-13.5-66.9-20.3-102.4-20.3-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5-24.4 23.9-43.5 51.7-56.9 82.8-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3 0.1-35.3-7-69.6-20.9-101.9z" />
    </svg>
  );

   const HeartIcon = props => <Icon component={HeartSvg} {...props} />;

  class Regusers extends React.Component {

    constructor(props){
        super(props)
        let me = this
        this.getAppDetails = this.getAppDetails.bind(me)
        this.getChildContainersDetail = this.getChildContainersDetail.bind(me)
        this.getReguContainer = this.getReguContainer.bind(me)
        this.deleteTaskCurryParams  = this.deleteTaskCurryParams.bind(me)

  
    }
    deleteTaskCurryParams = (param1, ctx)=>(event)=>{
		let me = ctx
		me.currentSelection = param1
		console.log('sv delete task curry')
		console.log(param1)
		me.props.svWrappedDeletereguserActionCreator(param1.id)
	}
    getAppDetails(paramQSpaceId){
        console.log('order detail confirmationcode**************', paramQSpaceId)
        this.props.loadReguserList(paramQSpaceId)
        // this.props.getSoDetails("mancreek")
 
       // this.props.ordAndImagesSV()
        
     }

     componentWillMount()	{
        console.log('sv--addresses=--- link sends us params')
        console.log(this.props.params)
         //console.log(this.props.params.id)
         let id = 2;
         if(this.props.params){
            id = this.props.params.id
         
         }else{
          console.log('not called by router')
          id = 1;
         }
        
    console.log('sbv--addressed for customer id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:'+ id)
    
    
       this.getAppDetails(id)
       // this.props.priceAndTexNow(id);
   
			
			
	

	}


     render() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title, orders} = this

        return (

            
            <div className="col-md-12">

                <MotelTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getChildContainersDetail()}></MotelTerrain>
            </div>
        )

    }

    getReguContainer(rev){

        return  (
            <div className="rev-row">
            <div className="card card--raised with-shadow">

                <p className="right-sd-content"> <span  >	<Link to={`/svregus/${rev.id ?rev.id :5}`}> <Icon  style={{ color: '#eeb838' }} type="edit" theme="filled" /> <text> {rev.fname ?rev.fname :'Allen' } {rev.lname ?rev.lname :'Bode' }  </text></Link></span><span  onClick={  this.deleteTaskCurryParams(rev, this)}><Icon  style={{ color: '#e30b29' }} type="delete" theme="filled" /></span></p>
                <p className="sd-check"> <text> Phone:  {rev.phone ?rev.phone :'408-1234-4123' } </text></p>
                <p className="sd-check"> <text> Email: {rev.email ?rev.email :'allen@yahoo.com' }</text></p>
                <p className="sd-check"> <text>  {rev.address ?rev.address :'12 Scotland ave' }</text></p>
               
                <p className="sd-check"> <text>  {rev.zip ? ( rev.state + ' ' +rev.zip ):'US' }</text></p>
                <p className="sd-check"> <text>  {rev.country ?rev.country :'US' }</text></p>

</div>
</div>

        )

    }
    getChildContainersDetail() {
        const lastestUpdateDate = 'Data Refresh Daily'
        const { title} = this
        let soj = null, data = [], hosts = [], dbs = [], sojourns = [] ,my_data = []
        //svreguserlistView
       
        let my_data_addresslist = [
            {
                "id": 1,
                "fname": "John",
                "lname": "Glen",
                "email": "john123@yahoo.com",
                "username": "pet123@yahoo.com",
                "password": "pet123",
                "encpassword": "pet123@yahoo.com",
                "phone": "5121234356"
            }
        ]
        if (this.props.my_data_addresslist ) {
            my_data_addresslist = this.props.my_data_addresslist
          
          
        }

        return (

            
           
            <div className="svr-det-pageWrapper">
                <header className="svr-header1">
                    <h1><span><Link to={`/svregus/-1`}> Abode Registered Users Information<Icon  style={{ color: '#eeb838' }} type="plus-square" theme="filled" /> </Link></span> </h1>
                </header>
        
              

                <div className="svr-gal-contentWrapper">
                    <article className="main">
                    {
                            my_data_addresslist.map(o => {
                                let soj = o
                                //convet keys of o to uppercase
                                console.log('sv***soj**')
                                console.log(soj)
                                

                                return (
                                    <CardTerrain  lastestUpdateDate={lastestUpdateDate} body={this.getReguContainer(o)}></CardTerrain>
                                    
                                )
                            })
                        }
                        
                    </article>
                </div>
            </div>
        )
    }


  }

  export default Regusers